module.exports = __webpack_public_path__ + "081477fe4790b0653442179d311f4aa4.svg";